import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import utc from 'dayjs/plugin/utc';

dayjs.extend(weekOfYear);
dayjs.extend(utc);

export class DateTimeUtils {
  /**
   * Converts a server timestamp (epoch ms at midnight UTC) into a local `Date`
   * set to midnight of the *same calendar day*. Without this, `dayjs(ts).toDate()`
   * shifts the day backwards in negative UTC offsets (e.g. D-1 21:00 in UTC-3).
   */
  static fromServerTimestamp(timestamp: number): Date {
    return dayjs(dayjs.utc(timestamp).format('YYYY-MM-DD')).toDate();
  }

  static getFormattedDurationFromString(str: string): string {
    var parts = str.split(':');
    var hours = parseInt(parts[0]);
    var minutes = parseInt(parts[1]);

    if (minutes === 0) {
      return `${hours} Std`;
    } else {
      return `${hours} Std ${minutes.toString().padStart(2, '0')} Min`;
    }
  }

  static getFormattedDuration(hours: number): string {
    var minutes = hours * 60;
    var hours = Math.floor(minutes / 60);
    var minutes = Math.floor(minutes % 60);

    if (minutes === 0) {
      return `${hours} Stunden`;
    } else {
      return `${hours} Stunden ${minutes.toString().padStart(2, '0')} Minuten`;
    }
  }

  static getFormattedDurationFromMinutes(minutes: number): string {
    var hrs = Math.floor(Math.abs(minutes / 60));
    var mins = Math.floor(Math.abs(minutes % 60));

    var result = `${minutes < 0 ? '-' : ''}${hrs} Std ${mins.toString().padStart(2, '0')} Min`;

    return result;
  }

  static getFormattedDurationInDays(
    days: number,
    minutenProTag: number,
  ): string {
    var calculatedDays = Math.floor(days);
    var totalMin = Math.round((days - calculatedDays) * minutenProTag);
    var calculatedHours = Math.floor(totalMin / 60.0);
    var calculatedMinutes = totalMin % 60;

    var result = '';
    if (calculatedDays > 0) {
      result += `${calculatedDays} Tag`;
      if (calculatedDays > 1) result += 'e';
      result += ' ';
    }
    if (calculatedHours > 0) {
      result += `${calculatedHours} Stunden `;
    }
    if (calculatedMinutes > 0) {
      result += `${calculatedMinutes} Minuten`;
    }

    return result.trim();
  }
}
